import React, { useState } from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { Star, UtensilsCrossed, ChefHat, Leaf } from 'lucide-react';

const ENTRANCE_IMAGE = "https://customer-assets.emergentagent.com/job_882d595f-ff74-4a1a-b1f3-db9ebf1484f1/artifacts/gtr04py8_WhatsApp%20Image%202026-03-26%20at%2012.30.52%20%281%29.jpeg";

const CATEGORY_IMAGES = {
  entrada: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/mkm7u8jw_Patatas%20Bravas.jpg",
  quesadillas: "https://images.unsplash.com/photo-1553621043-42d982218838?crop=entropy&cs=srgb&fm=jpg&w=600&h=400&fit=crop",
  tacos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/nppzerfn_Chicken%20Tacos.jpg",
  nachos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/durdbnx1_Tex%20Mex%20Chicken%20Nachos.jpg",
  burritos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/vh8qredt_Chipotle%20Paneer%20Burrito.jpg",
  fiestaBowls: "https://images.unsplash.com/photo-1743779665801-ae26f2d84525?crop=entropy&cs=srgb&fm=jpg&w=600&h=400&fit=crop",
  fajitas: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/x6zxb47k_Chicken%20Fajitas.jpg",
  enchiladas: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/9oip3hws_Enchiladas%281%29.jpg",
  specials: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/c3jodrna_WhatsApp%20Image%202026-04-15%20at%2018.24.46.jpeg",
  desserts: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/mar8qk2z_Churros.jpg",
  addons: "https://images.unsplash.com/photo-1701203236447-89a7016a5a40?crop=entropy&cs=srgb&fm=jpg&w=600&h=400&fit=crop",
  drinks: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/5rv2nke0_Mango%20Chilli.jpg"
};

const menuData = {
  entrada: {
    title: "Entrada",
    description: "Begin your fiesta with our authentic Mexican appetizers",
    items: [
      { name: "Guacamole", type: "Veg", description: "The classic dip, with fresh avocado, Pico de Gallo, lime, and house-made Casa Loco corn chips" },
      { name: "Elote (Street Corn)", type: "Veg", description: "A Mexican street-food favorite, corn on the cob grilled and coated with chipotle crema, spices, and crumbled Cotija cheese", chefSpecial: true },
      { name: "Chipotle Salsa Dip", type: "Veg", description: "Fresh & spicy dip with classic flavors, our own Chipotle in Adobo mixed with onion, Pico de Gallo, lime juice & coriander, with corn chips" },
      { name: "Patatas Bravas", type: "Veg", description: "Twice-cooked crunchy potatoes, spicy chipotle paprika, tomato sauce, queso fresco & Coriander Lime crema", chefSpecial: true },
      { name: "Queso", type: "Veg", description: "Oven-roasted vegetables & chilis mixed with spices, full cream & cheese. Served with Casa Loco corn chips" },
      { name: "Taquitos - Paneer", type: "Veg", description: "Crispy fried wheat tortillas filled with 3 cheeses and paneer, served with guacamole & salsa" },
      { name: "Taquitos - Tinga Chicken", type: "Non Veg", description: "Crispy fried wheat tortillas filled with 3 cheeses and tinga chicken, served with guacamole & salsa" }
    ]
  },
  nachos: {
    title: "Nachos",
    description: "Crisp tortilla chips stacked with layers of quality ingredients. Oven-heated with tasty melted cheese, and topped with salsas, and your choice of Casa Loco's tastiest options.",
    items: [
      { name: "Cheesy Nachos", type: "Veg" },
      { name: "Paneer Chipotle", type: "Veg" },
      { name: "Chicken Tex Mex", type: "Non Veg" },
      { name: "Chicken Tinga", type: "Non Veg" }
    ]
  },
  tacos: {
    title: "Tacos",
    description: "From the streets of Mexico, and a favourite around the world. Fresh and loaded with bold fillings, vegetables, meats, salsas, guacamole. Packed with flavour.",
    items: [
      { name: "Kid's Cheesy Taco", type: "Veg" },
      { name: "Kid's Chicken & Cheese Taco", type: "Non Veg" },
      { name: "Paneer Chipotle", type: "Veg" },
      { name: "Eggplant Asada", type: "Veg" },
      { name: "Gobhi Gobernador", type: "Veg" },
      { name: "Prawn Gobernador", type: "Non Veg", chefSpecial: true },
      { name: "Baja Fish", type: "Non Veg", chefSpecial: true },
      { name: "Chicken Chipotle", type: "Non Veg" },
      { name: "Chicken Tex Mex", type: "Non Veg" },
      { name: "Chicken Tinga", type: "Non Veg" },
      { name: "Lamb Barbacoa", type: "Non Veg" },
      { name: "Lamb Birria", type: "Non Veg" },
      { name: "Calor Mexicano", type: "Non Veg", description: "Our spiciest taco. Chicken Chorizo, with chilli refried beans, chipotle crema and guacamole" }
    ]
  },
  burritos: {
    title: "Burritos",
    description: "A hearty Mexican classic, soft tortilla wrapped and packed with Mexican rice, Casa Loco's signature refried beans, cheese, salsa, and your choice of fillings. Finished on the grill, big, bold, and satisfying.",
    items: [
      { name: "Viva Veg", type: "Veg" },
      { name: "Paneer Chipotle", type: "Veg" },
      { name: "Chicken Chipotle", type: "Non Veg" },
      { name: "Lamb Birria", type: "Non Veg" }
    ]
  },
  quesadillas: {
    title: "Quesadillas",
    description: "From the streets of Mexico, and a favourite around the world. Fresh and loaded with bold fillings, vegetables, meats, salsas, guacamole. Packed with flavour.",
    items: [
      { name: "Cheesy Quesadilla", type: "Veg", description: "Warm and Cheesy Tortilla with mozzarella, cheddar, and nacho cheese" },
      { name: "Paneer Chipotle", type: "Veg", description: "Grilled paneer with creamy chipotle sauce, cheese, and chipotle crema" },
      { name: "Chicken Chipotle", type: "Non Veg", description: "Grilled chicken, creamy chipotle adobo, melted cheese, and coriander-lime crema" },
      { name: "Chicken Tex Mex", type: "Non Veg", description: "The flavours of classic Tex-Mex, slow-cooked chicken, cheese, and Casa Loco Taco Sauce" },
      { name: "Chicken Tinga", type: "Non Veg", description: "Classic Puebla dish: Tomato and chilli-flavored shredded chicken, cheese, and coriander-lime crema" },
      { name: "Prawn Quesadilla", type: "Non Veg", description: "Grilled prawn with creamy chipotle sauce, cheese, and chipotle crema", chefSpecial: true }
    ]
  },
  enchiladas: {
    title: "Enchiladas",
    description: "A warm taste of every abuela's kitchen. Traditional enchiladas — fresh tortilla, filled with slow-cooked meats or vegetables, baked in a rich enchilada sauce with molten cheese for true cantina comfort. Served with guacamole, Pico de Gallo, Mexican rice, and refried beans.",
    items: [
      { name: "Viva Veg", type: "Veg" },
      { name: "Paneer Chipotle", type: "Veg" },
      { name: "Chicken Chipotle", type: "Non Veg" },
      { name: "Chicken Tinga", type: "Non Veg" },
      { name: "Chicken Tex Mex", type: "Non Veg" },
      { name: "Lamb Barbacoa", type: "Non Veg", chefSpecial: true }
    ]
  },
  fajitas: {
    title: "Fajitas",
    description: "Sizzling and full of life, Casa Loco fajitas arrive on a hot grill plate with your choice of chicken, prawn, or paneer. Always made fresh and cooked to order, with onions, vibrant peppers, and spices. With warm tortillas, salsa, guacamole, and sour cream.",
    items: [
      { name: "Paneer", type: "Veg", description: "Grilled paneer with onion, capsicum and seasonings, served on a sizzling hot plate with warm tortillas, tomato salsa, guacamole & sour cream" },
      { name: "Chicken", type: "Non Veg", description: "Chicken breast strips grilled with onion, capsicum and seasonings, served on a sizzling hot plate with warm tortillas, tomato salsa, guacamole & sour cream" },
      { name: "Prawn", type: "Non Veg", description: "Grilled prawn with onion, capsicum and seasonings, served on a sizzling hot plate with warm tortillas, tomato salsa, guacamole & sour cream", chefSpecial: true }
    ]
  },
  fiestaBowls: {
    title: "Fiesta Bowls",
    description: "A Mexican feast in one vibrant bowl, with our signature slow-cooked meats, zesty and spiced Mexican rice, refried beans, crisp vegetables, salsas, and guacamole. A colorful fiesta that shows real food doesn't need shortcuts.",
    items: [
      { name: "Paneer Chipotle", type: "Veg", description: "Chipotle Crema" },
      { name: "Chipotle Chicken", type: "Non Veg", description: "Chipotle crema, Coriander lime Sauce" },
      { name: "Tex-Mex Chicken", type: "Non Veg", description: "Taco Sauce" },
      { name: "Grilled Shrimp", type: "Non Veg", description: "Achiote-spiced shrimp and chipotle crema" },
      { name: "Lamb Barbacoa", type: "Non Veg", description: "Casa Loco Taco Sauce" }
    ]
  },
  specials: {
    title: "A Taste of Mexico",
    description: "A bold celebration of Casa Loco's favourite flavours. Slow-cooked Birria Lamb, succulent Pork Carnitas, smoky Tinga Chicken, plus vibrant vegetarian favourites. Served with Mexican rice, refried beans, grilled fajita vegetables, Patatas Bravas, Elote Street Corn, warm tortillas, guacamole, Pico de Gallo, and Casa Loco salsas. A true feast to share.",
    items: [
      { name: "Taste of Mexico - Veg", type: "Veg", chefSpecial: true },
      { name: "Taste of Mexico - Non Veg", type: "Non Veg", chefSpecial: true }
    ]
  },
  desserts: {
    title: "Desserts",
    description: "Every Mexican feast needs a sweet finish",
    items: [
      { name: "Churros - Single", type: "Veg", description: "Golden, crispy, soft-centred, dusted in cinnamon sugar with a rich dark chocolate dipping sauce" },
      { name: "Churros - Shared", type: "Veg", description: "Golden, crispy, soft-centred, dusted in cinnamon sugar with a rich dark chocolate dipping sauce" }
    ]
  },
  addons: {
    title: "Adiciones",
    description: "Customize your meal with extras",
    items: [
      { name: "Pico De Gallo", type: "Veg" },
      { name: "Pickled Red Onion", type: "Veg" },
      { name: "Lettuce", type: "Veg" },
      { name: "Jalapenos", type: "Veg" },
      { name: "Refried Beans", type: "Veg" },
      { name: "Sour Cream", type: "Veg" },
      { name: "Mozzarella Cheese", type: "Veg" },
      { name: "Paneer", type: "Veg" },
      { name: "Nacho Cheese", type: "Veg" },
      { name: "Guacamole", type: "Veg" },
      { name: "Chicken", type: "Non Veg" }
    ]
  },
  drinks: {
    title: "Non-Alcoholic Drinks",
    description: "Refreshing beverages for everyone",
    items: [
      { name: "Coke", type: "Veg" },
      { name: "Diet Coke", type: "Veg" },
      { name: "Fanta", type: "Veg" },
      { name: "Red Bull", type: "Veg" },
      { name: "Sprite", type: "Veg" },
      { name: "Ginger Ale", type: "Veg" },
      { name: "Horchata", type: "Veg", description: "Creamy rice milk with cinnamon" },
      { name: "Tonic Water", type: "Veg" },
      { name: "Mocktails", type: "Veg" },
      { name: "Water - 1L", type: "Veg" }
    ]
  }
};

const categories = ['entrada', 'nachos', 'tacos', 'burritos', 'quesadillas', 'enchiladas', 'fajitas', 'fiestaBowls', 'specials', 'desserts', 'addons', 'drinks'];

const FoodMenuPage = () => {
  const [activeCategory, setActiveCategory] = useState('entrada');
  const [filterVeg, setFilterVeg] = useState(false);

  const currentCategory = menuData[activeCategory];
  const filteredItems = filterVeg 
    ? currentCategory.items.filter(item => item.type === 'Veg')
    : currentCategory.items;

  return (
    <Layout>
      <SEO
        title="Authentic Mexican Menu | Tacos, Burritos & Churros at Casa Loco Hyderabad"
        description="Explore the best Mexican food in Gachibowli. From street-style tacos to loaded burritos and fresh churros, see what's cooking at Casa Loco."
        path="/food-menu"
      />
      <div className="min-h-screen paper-texture" style={{ paddingTop: '76px' }} data-testid="food-menu-page">
        {/* Hero */}
        <div className="relative" style={{ borderBottom: '4px solid #1A1918' }}>
          <div className="relative h-[280px] sm:h-[320px] lg:h-[380px] overflow-hidden">
            <img src={ENTRANCE_IMAGE} alt="Casa Loco Restaurant" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1918] via-black/50 to-transparent" />
          </div>
          <div className="absolute bottom-0 left-0 right-0 pb-8 pt-16 text-center">
            <div className="flex items-center justify-center gap-4 mb-3">
              <Star size={10} fill="#F7B638" stroke="none" />
              <UtensilsCrossed style={{ width: '36px', height: '36px', color: '#F7B638' }} />
              <Star size={10} fill="#F7B638" stroke="none" />
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mb-3" style={{ textShadow: '3px 3px 0 rgba(0,0,0,0.5)' }} data-testid="food-menu-title">
              FOOD MENU
            </h1>
            <div className="zigzag-divider max-w-xs mx-auto mb-4" />
            <p className="font-mono text-white/80 text-sm max-w-lg mx-auto">
              Authentic Mexican dishes, sized and spiced for India
            </p>
          </div>
        </div>

        {/* Category Navigation */}
        <div className="sticky top-[76px] z-40" style={{ backgroundColor: '#1A1918', borderBottom: '3px solid #F7B638' }}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="sm:hidden py-3">
              <select
                value={activeCategory}
                onChange={(e) => setActiveCategory(e.target.value)}
                className="w-full px-4 py-3 font-display text-sm tracking-wide appearance-none cursor-pointer"
                style={{ 
                  backgroundColor: '#F7B638', color: '#1A1918', border: '2px solid #1A1918',
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%231A1918' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                  backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center', backgroundSize: '20px'
                }}
                data-testid="mobile-category-select"
              >
                {categories.map((cat) => (
                  <option key={cat} value={cat}>{menuData[cat].title.toUpperCase()}</option>
                ))}
              </select>
              <p className="text-center text-white/50 text-xs font-mono mt-2">{categories.length} categories available</p>
            </div>
            <div className="hidden sm:flex items-center justify-between py-2">
              <div className="flex-1 overflow-x-auto scrollbar-hide">
                <div className="flex gap-1 sm:gap-2 pb-1">
                  {categories.map((cat) => (
                    <button key={cat} onClick={() => setActiveCategory(cat)}
                      className={`whitespace-nowrap px-3 py-2 font-display text-xs sm:text-sm tracking-wide transition-all ${activeCategory === cat ? 'text-[#1A1918]' : 'text-white/70 hover:text-white'}`}
                      style={activeCategory === cat ? { backgroundColor: '#F7B638' } : {}}
                      data-testid={`category-${cat}`}
                    >
                      {menuData[cat].title.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>
              <button onClick={() => setFilterVeg(!filterVeg)}
                className={`ml-4 flex items-center gap-1.5 px-3 py-2 font-mono text-xs transition-all ${filterVeg ? 'text-[#1A1918]' : 'text-white/70'}`}
                style={filterVeg ? { backgroundColor: '#51A262' } : { border: '1px solid #51A262' }}
                data-testid="veg-filter"
              >
                <Leaf size={14} /> VEG
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Veg Filter */}
        <div className="sm:hidden px-4 py-3" style={{ backgroundColor: '#F4EFE6', borderBottom: '2px solid #1A1918' }}>
          <button onClick={() => setFilterVeg(!filterVeg)}
            className={`w-full flex items-center justify-center gap-2 px-4 py-2 font-mono text-sm transition-all ${filterVeg ? 'text-white' : 'text-[#1A1918]'}`}
            style={filterVeg ? { backgroundColor: '#51A262', border: '2px solid #1A1918' } : { backgroundColor: 'white', border: '2px solid #51A262' }}
            data-testid="mobile-veg-filter"
          >
            <Leaf size={16} /> {filterVeg ? 'SHOWING VEG ONLY' : 'FILTER VEG ONLY'}
          </button>
        </div>

        {/* Menu Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
          <div className="grid lg:grid-cols-2 gap-6 mb-10">
            <div className="aspect-video lg:aspect-[4/3] overflow-hidden order-2 lg:order-1" style={{ border: '4px solid #1A1918', boxShadow: '6px 6px 0 #1A1918' }}>
              <img src={CATEGORY_IMAGES[activeCategory]} alt={currentCategory.title} className="w-full h-full object-cover" />
            </div>
            <div className="flex flex-col justify-center order-1 lg:order-2">
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mb-4" style={{ color: '#1A1918' }}>
                {currentCategory.title.toUpperCase()}
              </h2>
              <p className="font-mono text-[#4A4641] text-sm leading-relaxed mb-6">{currentCategory.description}</p>
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center gap-2 px-4 py-2 font-mono text-sm" style={{ backgroundColor: '#F7B638', border: '2px solid #1A1918' }}>
                  <UtensilsCrossed size={16} /> {filteredItems.length} items
                </span>
                {currentCategory.items.some(item => item.chefSpecial) && (
                  <span className="inline-flex items-center gap-1 px-3 py-2 font-mono text-xs" style={{ backgroundColor: '#EE2535', color: 'white' }}>
                    <ChefHat size={14} /> Chef's Specials Available
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="grid gap-3 sm:gap-4">
            {filteredItems.map((item, idx) => (
              <div key={idx}
                className="flex items-center p-4 sm:p-5 bg-white transition-transform hover:translate-x-[-2px] hover:translate-y-[-2px]"
                style={{ border: '2px solid #1A1918', boxShadow: '3px 3px 0 #1A1918' }}
                data-testid={`menu-item-${idx}`}
              >
                <div className="flex items-center gap-3 sm:gap-4 flex-1">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center" style={{ border: `2px solid ${item.type === 'Veg' ? '#51A262' : '#EE2535'}` }}>
                    <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: item.type === 'Veg' ? '#51A262' : '#EE2535' }} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-display text-base sm:text-lg" style={{ color: '#1A1918' }}>{item.name}</h3>
                      {item.chefSpecial && (
                        <span className="inline-flex items-center gap-1 text-[10px] font-mono font-bold px-1.5 py-0.5 uppercase" style={{ backgroundColor: '#F7B638', color: '#1A1918' }}>
                          <ChefHat size={10} /> Chef's Special
                        </span>
                      )}
                    </div>
                    {item.description && (
                      <p className="font-mono text-xs text-[#4A4641] mt-0.5">{item.description}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredItems.length === 0 && (
            <div className="text-center py-12">
              <p className="font-mono text-[#4A4641]">No vegetarian items in this category</p>
            </div>
          )}
        </div>

        {/* Complete Menu - SEO Text (all categories crawlable) */}
        <div className="paper-texture py-12" style={{ borderTop: '4px solid #1A1918' }}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="font-display text-2xl sm:text-3xl text-center mb-8" style={{ color: '#1A1918' }}>
              Complete Food Menu
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {categories.map((catKey) => {
                const cat = menuData[catKey];
                return (
                  <div key={catKey} className="bg-white p-5" style={{ border: '2px solid #1A1918', boxShadow: '3px 3px 0 #1A1918' }}>
                    <h3 className="font-display text-lg mb-1" style={{ color: '#EE2535' }}>{cat.title}</h3>
                    <ul className="space-y-1">
                      {cat.items.map((item, i) => (
                        <li key={i} className="font-mono text-xs text-[#4A4641] flex items-start gap-2">
                          <span className="w-2 h-2 mt-1 rounded-full flex-shrink-0" style={{ backgroundColor: item.type === 'Veg' ? '#51A262' : '#EE2535' }} />
                          <span>{item.name}{item.description ? ` — ${item.description}` : ''}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="py-10 text-center" style={{ backgroundColor: '#1A1918', borderTop: '4px solid #1A1918' }}>
          <p className="font-mono text-gray-500 text-sm mb-4">Looking for cocktails and margaritas?</p>
          <a href="/drinks-menu" className="inline-block px-8 py-3 font-display tracking-wider text-base transition-transform hover:translate-x-[-2px] hover:translate-y-[-2px]"
            data-testid="food-to-drinks-btn"
            style={{ backgroundColor: '#F7B638', color: '#1A1918', border: '3px solid #F7B638', boxShadow: '3px 3px 0 rgba(247,182,56,0.4)' }}>
            VIEW DRINKS MENU
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default FoodMenuPage;